import Button from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle
} from '@atlaskit/modal-dialog';

interface SignupFeatureModalProps {
  onClose: (accept: boolean) => void;
}

export const SignupFeatureModal = ({ onClose }: SignupFeatureModalProps) => {
  return (
    <Modal onClose={() => onClose(false)} width="small">
      <ModalHeader>
        <ModalTitle>{'Sign up to add images.'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <p>
          {
            'To get the full editor experience, sign up for a free Confluence site.'
          }
        </p>
      </ModalBody>
      <ModalFooter>
        <Button appearance="subtle" onClick={() => onClose(false)}>
          {'Keep editing'}
        </Button>
        <Button appearance="primary" onClick={() => onClose(true)} autoFocus>
          {'Sign up'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
